<div class="custom-header">
    @if (!params.isShowTooltip) {
    <div class="main-title">{{ params.displayName }}</div>
    } @else {
    <div class="main-title" cdkOverlayOrigin #viewToolTipTrigger="cdkOverlayOrigin" (click)="toggleOverlay()">
        {{ params.displayName }}
        <span porIcon icon="info"></span>
    </div>
    <por-overlay [layout]="'tooltip-panel'" [featureName]="'view-tooltip'" [isOpen]="overlayStates" [trigger]="viewToolTipTrigger" (closeOverlayClick)="toggleOverlay()">
        @if (params.tooltipTitle) {
        <h3 class="mr-18">{{ params.tooltipTitle }}</h3>
        } @if (params.tooltipContent) {
        <div [innerHTML]="params.tooltipContent" class="list-item"></div>
        }
    </por-overlay>
    } @if (params.subTitle) {
    <div class="sub-title">({{ params.subTitle }})</div>
    }
</div>
